import { useEffect, useState } from "react";

const DEFAULT_LOCATION = {
  lat: 40.7128,
  lng: -74.0060,
};

export const useCurrentLocation = () => {
  const [location, setLocation] = useState(DEFAULT_LOCATION);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!navigator.geolocation) {
      console.error("Geolocation NOT supported");
      setLoaded(true);
      return;
    }
  
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        console.log("SUCCESS:", pos.coords);
        setLocation({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        });
        setLoaded(true);
      },
      (err) => {
        console.error("GEO ERROR:", err.code, err.message);
        setLoaded(true);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  }, []);
  console.log("location1",location)

  return { location, loaded };
};
